//  示例
import http from '@/utils/http';

// 网页
export const scalePage = {
    url: "/api/adhd/v2/scalePage",
    list: function (params) {
        return http({
            url: scalePage.url + '/list',
            method: "get",
            params
        })
    },
    add: function (data) {
        return http({
            url: scalePage.url,
            method: "post",
            data
        })
    },
    del: function (id) {
        return http({
            url: scalePage.url + '?' + `id=${id}`,
            method: "delete",

        })
    },
    edit: function (data) {
        return http({
            url: scalePage.url,
            method: "put",
            data
        })
    },
}

// 每一题
export const scale = {
    url: "/api/adhd/v2/scale",
    list: function (params) {
        return http({
            url: scale.url + '/list',
            method: "get",
            params
        })
    },
    add: function (data) {
        return http({
            url: scale.url,
            method: "post",
            data
        })
    },
    del: function (id) {
        return http({
            url: scale.url + '?' + `id=${id}`,
            method: "delete",

        })
    },
    edit: function (data) {
        return http({
            url: scale.url,
            method: "put",
            data
        })
    },
} 
